import { queryKeys } from "@lib/api/queryKeys";

const fetchUserById = async (userId, token) => {
  const response = await fetch(`/api/users/${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error("Failed to fetch user");
  return response.json();
};

export const currentUserQueryOptions = (userId, token) => ({
  queryKey: queryKeys.users.detail(userId),
  queryFn: () => fetchUserById(userId, token),
  staleTime: 10 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
  retry: 1,
  refetchOnWindowFocus: false,
  enabled: !!userId && !!token,
});

export const userQueryOptions = (userId, token) => ({
  queryKey: queryKeys.users.detail(userId),
  queryFn: () => fetchUserById(userId, token),
  staleTime: 10 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
  retry: 1,
  refetchOnWindowFocus: false,
  enabled: !!userId && !!token,
});
